import React from "react"

/**
 * @param {{
 *   isSidebarCollapsed: boolean,
 *   mobileTopBar: React.ReactNode,
 *   children: React.ReactNode,
 * }} props
 */
export function NavMainColumn({ isSidebarCollapsed, mobileTopBar, children }) {
    return (
        <div
            className={
                "main-content min-vh-100 d-flex flex-column" +
                (isSidebarCollapsed ? " collapsed" : "")
            }
            style={{ minWidth: 0 }}
        >
            {mobileTopBar}
            <div className="v2-page-body flex-grow-1 d-flex flex-column">
                {children}
            </div>
        </div>
    )
}
